import React from 'react';
import PropTypes from 'prop-types';

export const KidsDropdownItem = ({ value, onChange }) => {
    const onClick = () => onChange(value);

    return (
        <li
            className='odf-dropdown-item'
            data-testid={`kids-dropdown-age-${value}`}
            onClick={onClick}
        >{ value }
        </li>
    );
};

KidsDropdownItem.propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
};
